import React, { ReactNode } from "react";
import * as S from "./style";
import ModalDefault from "components/ModalDefault";

export interface PopupProps {
  visible: boolean;
  content?: ReactNode;
  okEvent?: () => void;
}

const ImagePopup: React.FC<PopupProps> = ({ visible, content, okEvent }) => {
  const handleImageRightClick = (e: React.MouseEvent<HTMLImageElement>) => {
    e.preventDefault();
  };

  return (
    <S.ModalPopup visible={visible} closable={false} footer={null} centered>
      <S.InnerWrapper>
        <S.ContentWrapper onContextMenu={handleImageRightClick}>{content}</S.ContentWrapper>
        <S.ButtonConfirm onClick={okEvent}>닫기</S.ButtonConfirm>
      </S.InnerWrapper>
    </S.ModalPopup>
  );
};

export default ImagePopup;
